import isArrayLike from './is-array-like';
export default function head(o) {
  if (isArrayLike(o)) {
    return o[0];
  }

  return undefined;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/head.js
// module id = 47
// module chunks = 0